import Main from './main'

export default {
  install (Vue, options = {}) {
    const Picker = Vue.extend(Main)
    function $exportDialog (data) {
      // if ( !type ) {
      //   throw new Error('type should not be undefined')
      // }

      const { data: dataVal } = data
      data = {
        ...options,
        value: {
          data: dataVal
        },
        isShow: true
      }

      return new Promise((reslove) => {
        const vm = new Picker({
          propsData: data,
          created () {
            const destory = () => {
              this.$destroy()
              this.$el.remove()
            }

            this.$once('close', destory)
            this.$once('input', (val) => {
              reslove(val)
              destory()
            })
          }
        }).$mount()
        document.body.appendChild(vm.$el)
      })
    }

    Vue.prototype.$exportDialog = $exportDialog
  }
}
